import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { AiResponderDetectionSensivity, AiResponderSettings } from '../../store/ai-settings.model'
import { Store, select } from '@ngrx/store'
import { UpdateAISettings } from '../../store/ai-settings.actions'
import { selectAISettingsIsSaving } from '../../store/ai-settings.selectors'
import { Destroyable } from '@tokeet-frontend/tv3-platform'
import { AiIncidentNotificationComponent } from './ai-incident-notification/ai-incident-notification.component'

@Component({
  selector: 'app-ai-responder-incident-task',
  templateUrl: './ai-responder-incident-task.component.html',
  styleUrls: ['./ai-responder-incident-task.component.scss'],
})
export class AiResponderIncidentTaskComponent extends Destroyable implements OnInit {
  @ViewChild(AiIncidentNotificationComponent) incidentNotification: AiIncidentNotificationComponent
  @Input() settings: AiResponderSettings

  incidentTaskForm = this.fb.group({
    canCreateIncidents: [false],
    canCreateIncidentsFromReviews: [true],
    detectionSensivity: [0],
  })
  isSaving$ = this.store.pipe(select(selectAISettingsIsSaving))

  constructor(private fb: FormBuilder, private store: Store) {
    super()
  }

  ngOnInit() {
    this.incidentTaskForm.patchValue({
      canCreateIncidents: this.settings.canCreateIncidents,
      canCreateIncidentsFromReviews: this.settings.canCreateIncidentsFromReviews,
      detectionSensivity: this.getSensivityValue(this.settings.detectionSensivity),
    })
  }

  getSensivityLabel(value: number) {
    return value === 0
      ? AiResponderDetectionSensivity.LOW
      : value === 5
      ? AiResponderDetectionSensivity.MEDIUM
      : AiResponderDetectionSensivity.HIGH
  }

  getSensivityValue(value: AiResponderDetectionSensivity) {
    return value === AiResponderDetectionSensivity.LOW ? 0 : value === AiResponderDetectionSensivity.MEDIUM ? 5 : 10
  }

  onSave() {
    if (!this.incidentNotification.isValid()) {
      return
    }
    this.incidentNotification.save()
    const formValue = this.incidentTaskForm.getRawValue()
    this.store.dispatch(
      UpdateAISettings({
        payload: {
          canCreateIncidents: formValue.canCreateIncidents,
          canCreateIncidentsFromReviews: formValue.canCreateIncidentsFromReviews,
          detectionSensivity: this.getSensivityLabel(formValue.detectionSensivity),
        },
        message: $localize`Incidents settings have been updated successfully `,
      })
    )
  }
}
